// extracted by mini-css-extract-plugin
export default {"bodyBackground":"styles_bodyBackground__RRYFI","loadingContainer":"styles_loadingContainer__Hujti","loader":"styles_loader__Levvb"};